var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToogleclose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_2313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6618 3.99829H5.33079C3.12261 3.99829 1.33252 5.78838 1.33252 7.99657C1.33252 10.2048 3.12261 11.9948 5.33079 11.9948H10.6618C12.87 11.9948 14.6601 10.2048 14.6601 7.99657C14.6601 5.78838 12.87 3.99829 10.6618 3.99829Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33081 9.32933C6.06687 9.32933 6.66356 8.73264 6.66356 7.99658C6.66356 7.26051 6.06687 6.66382 5.33081 6.66382C4.59474 6.66382 3.99805 7.26051 3.99805 7.99658C3.99805 8.73264 4.59474 9.32933 5.33081 9.32933Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_2313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToogleclose);
export default __webpack_public_path__ + "static/media/toogleclose.a4eb54999aadfbc1aceb5034b38081e6.svg";
export { ForwardRef as ReactComponent };